import { getCartLineItems } from '../../../../lib/getCartLineItems';
import { useCartState } from '../../cartFacade/useCartState';

export const useGetCartLineItems = () => {
  const { cart } = useCartState();

  return getCartLineItems({
    cart: cart ?? {},
    posCartTotals: cart?.pos_cart.totals ?? undefined,
    tipAmount: cart?.tip_amount ?? 0,
  });
};
